export default __webpack_public_path__ + "static/media/Loader.6fdf6f7f.gif";